export const COLORS_LIST = [
    'border-[#6366F1]',
    'border-[#EF4444]',
    'border-[#10B981]',
    'border-[#F59E0B]',
]